import { render } from "./SavedListContainer.vue?vue&type=template&id=e34aa026"
import script from "./SavedListContainer.vue?vue&type=script&lang=js"
export * from "./SavedListContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__